export function jsonToFormData(
  json: Record<string, unknown>,
  formData = new FormData(),
  parentKey = "",
): FormData {
  for (const key in json) {
    if (!Object.hasOwn(json, key)) continue;

    const value = json[key];
    const fullKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File) {
      formData.append(fullKey, value);
    } else if (typeof value === "object" && value !== null && !(value instanceof Date)) {
      // @ts-expect-error TODO Add type
      jsonToFormData(value, formData, fullKey); // Recursively handle nested objects
    } else {
      // @ts-expect-error TODO Add type
      formData.append(fullKey, value ?? "");
    }
  }

  return formData;
}
